import UserRoleMap from "@/components/Common/UserRoleMap";
import { Notification } from "element-ui";
import socket from "@/services/socket.service";

export default {
  name: "TheCustomerBasicData",

  components: { UserRoleMap },

  props: {
    user: {
      type: Object,
      default: () => ({})
    }
  },

  mounted() {
    this.handleConnectToSocketWhenUserLogged();
  },

  methods: {
    handleConnectToSocketWhenUserLogged() {
      if (!this.$store.getters["authorization/user"]) {
        return;
      }
      socket.handleSocketDisconnect(() => {
        setTimeout(async () => {
          if (!socket.isSocketConnected()) {
            this.$store.dispatch("global/toogleServerSocketConnection", false);
            await this.$store.dispatch('authorization/checkIfUserSessionExists', { endpoint: '/authorization/checkIfUserSessionExist' });
            if (this.$store.getters["authorization/user"] !== null) {
              Notification.error({
                title: "Error",
                message: "Nastąpiło chwilowe rozłączenie z serwerem Online"
              });
            } else {
              this.$router.push({ name: 'LoginRegister' });
            }
          }
        }, 2000);
      });
    }
  }
};
